// extracted by mini-css-extract-plugin
module.exports = {"landing_page_C":"B1_landing_page_C__ZA2ao"};